import { useState, useEffect } from "react";

import './Details.css';

import Select from 'react-select';

import JoditEditor from 'jodit-react';
import { config } from "fixedData";

import { SetModalData, SetModalState } from "interface/PopUp";
import { GetUserData, RegisterUserData } from "interface/Users";
import { GetDataPage, RegisterDataPage } from "interface/Data";
import { GetListPag, RegisterListPag, SetListPag } from "interface/Page";

import { Reg_PartService } from "services/RegisterData";

import { SvgAddData, SvgCopy, SvgDelete, SvgImg, SvgSave, SvgSetaRight, SvgTable, SvgVideo } from "components/SvgFile";

export default function Page_PartsServices_Details(){

    const [ loading, setLoading ]       = useState(false);
    const [ idUser, setIdUser ]         = useState(GetUserData("id"));
    const [ dataPage, setDataPage ]     = useState(GetDataPage('mesa_part_service_data'));
    const [ showButton, setShowButton ] = useState(GetDataPage('mesa_part_service_buttons'));
    const [ idPage, setIdPage ]         = useState(GetListPag('currentPageId'));

    const [ idioma, setIdioma ] = useState('pt_br');

    const [ type, setType ]         = useState(InitialData(idioma, 'id_given'));
    const [ machine, setMachine ]   = useState(InitialData(idioma, 'machine'));

    const [ namePtBr, setNamePtBr ] = useState(InitialData(idioma, 'name_pt_br'));
    const [ nameEn, setNameEn ]     = useState(InitialData(idioma, 'name_en'));
    const [ nameEs, setNameEs ]     = useState(InitialData(idioma, 'name_es'));

    const [ position, setPosition ]   = useState(InitialData(idioma, 'position'));
    const [ stamp_1, setStamp_1 ]     = useState(InitialData(idioma, 'stamp_1'));
    const [ stamp_2, setStamp_2 ]     = useState(InitialData(idioma, 'stamp_2'));
    const [ contents, setContents ]   = useState(InitialData(idioma, 'contents'));
    const [ highlight, setHighlight ] = useState(InitialData(idioma, 'highlight'));

    const [ subtitlePtBr, setSubtitlePtBr ] = useState(InitialData(idioma, 'subtitle_pt_br'));
    const [ subtitleEn, setSubtitleEn ]     = useState(InitialData(idioma, 'subtitle_en'));
    const [ subtitleEs, setSubtitleEs ]     = useState(InitialData(idioma, 'subtitle_es'));

    const [ iconePtBr, setIconePtBr ] = useState(InitialData(idioma, 'icone_pt_br'));
    const [ iconeEn, setIconeEn ]     = useState(InitialData(idioma, 'icone_en'));
    const [ iconeEs, setIconeEs ]     = useState(InitialData(idioma, 'icone_es'));

    const [ qrCode, setQrCode ] = useState(InitialData(idioma, 'qrCode'));

    const [ titlePtBr, setTitlePtBr ] = useState(InitialData(idioma, 'title_pt_br'));
    const [ titleEn, setTitleEn ]     = useState(InitialData(idioma, 'title_en'));
    const [ titleEs, setTitleEs ]     = useState(InitialData(idioma, 'title_es'));

    const [ imgQrCodePtBr, setImgQrCodePtBr ] = useState(InitialData(idioma, 'imgQrCode_pt_br'));
    const [ imgQrCodeEn, setImgQrCodeEn ]     = useState(InitialData(idioma, 'imgQrCode_en'));
    const [ imgQrCodeEs, setImgQrCodeEs ]     = useState(InitialData(idioma, 'imgQrCode_es'));

    const [ statusIconePtBr, setStatusIconePtBr ] = useState(false);
    const [ statusIconeEn, setStatusIconeEn ]     = useState(false);
    const [ statusIconeEs, setStatusIconeEs ]     = useState(false);

    const [ statusQrCodePtBr, setStatusQrCodePtBr ] = useState(false);
    const [ statusQrCodeEn, setStatusQrCodeEn ]     = useState(false);
    const [ statusQrCodeEs, setStatusQrCodeEs ]     = useState(false);

    const [ textFixed, setTextFixed ] = useState({
        "text_1": {
            "pt_br": "Dados da mesa - Peças e serviços",
            "en": "Table Dice - Parts and Service",
            "es": "Dados de mesa - Piezas y servicio"
        },
        "text_2": {
            "pt_br": "Origem",
            "en": "Origin",
            "es": "Origen"
        },
        "text_3": {
            "pt_br": "Posição",
            "en": "Position",
            "es": "Posición"
        },
        "text_4": {
            "pt_br": "Selo garantia",
            "en": "Guarantee seal",
            "es": "Sello de garantía"
        },
        "text_5": {
            "pt_br": "Selo financiamento",
            "en": "Financing stamp",
            "es": "Sello de financiacion"
        },
        "text_8": {
            "pt_br": "Conteúdo",
            "en": "Content",
            "es": "Contenido"
        },
        "text_9": {
            "pt_br": "Tipo",
            "en": "Type",
            "es": "Tipo"
        },
        "text_10": {
            "pt_br": "Imagem",
            "en": "Image",
            "es": "Imagen"
        },
        "text_11": {
            "pt_br": "Texto",
            "en": "Text",
            "es": "Texto"
        },
        "text_12": {
            "pt_br": "Adicionar imagem",
            "en": "Add image",
            "es": "Añadir imagen"
        },
        "text_13": {
            "pt_br": "Imagem adicionada",
            "en": "Image added",
            "es": "Imagen añadida"
        },
        "text_14": {
            "pt_br": "Adicionar vídeo",
            "en": "Add video",
            "es": "Añadir video"
        },
        "text_15": {
            "pt_br": "Vídeo adicionada",
            "en": "Video added",
            "es": "Vídeo añadido"
        },
        "text_16": {
            "pt_br": "Nome",
            "en": "Name",
            "es": "Nombre"
        },
        "text_17": {
            "pt_br": "Título",
            "en": "Title",
            "es": "Título"
        },
        "text_18": {
            "pt_br": "Adicionar QrCode",
            "en": "Add QrCode",
            "es": "Agregar QrCode"
        },
        "text_19": {
            "pt_br": "QrCode adicionada",
            "en": "QrCode added",
            "es": "QrCode añadido"
        }
    });

    useEffect(()=>{
        RegisterUserData('id', setIdUser);
        RegisterDataPage('mesa_part_service_data', setDataPage);
        RegisterDataPage('mesa_part_service_buttons', setShowButton);
        RegisterListPag('currentPageId', setIdPage);
    }, []);

    useEffect(()=>{
        setDataPage(GetDataPage('mesa_part_service_data'));
        setShowButton(GetDataPage('mesa_part_service_buttons'));
        setIdPage(GetListPag('currentPageId'));

        setType(InitialData(idioma, 'id_given'));
        setMachine(InitialData(idioma, 'machine'));

        setNamePtBr(InitialData(idioma, 'name_pt_br'));
        setNameEn(InitialData(idioma, 'name_en'));
        setNameEs(InitialData(idioma, 'name_es'));

        setPosition(InitialData(idioma, 'position'));
        setStamp_1(InitialData(idioma, 'stamp_1'));
        setStamp_2(InitialData(idioma, 'stamp_2'));
        setContents(InitialData(idioma, 'contents'));
        setHighlight(InitialData(idioma, 'highlight'));

        setSubtitlePtBr(InitialData(idioma, 'subtitle_pt_br'));
        setSubtitleEn(InitialData(idioma, 'subtitle_en'));
        setSubtitleEs(InitialData(idioma, 'subtitle_es'));

        setIconePtBr(InitialData(idioma, 'icone_pt_br'));
        setIconeEn(InitialData(idioma, 'icone_en'));
        setIconeEs(InitialData(idioma, 'icone_es'));

        setQrCode(InitialData(idioma, 'qrCode'));

        setTitlePtBr(InitialData(idioma, 'title_pt_br'));
        setTitleEn(InitialData(idioma, 'title_en'));
        setTitleEs(InitialData(idioma, 'title_es'));

        setImgQrCodePtBr(InitialData(idioma, 'imgQrCode_pt_br'));
        setImgQrCodeEn(InitialData(idioma, 'imgQrCode_en'));
        setImgQrCodeEs(InitialData(idioma, 'imgQrCode_es'));

        setStatusIconePtBr(false);
        setStatusIconeEn(false);
        setStatusIconeEs(false);

        setStatusQrCodePtBr(false);
        setStatusQrCodeEn(false);
        setStatusQrCodeEs(false);
    }, [dataPage]);

    useEffect(()=>{
        setDataPage(GetDataPage('mesa_part_service_data'));
        setShowButton(GetDataPage('mesa_part_service_buttons'));
        setIdPage(GetListPag('currentPageId'));

        setType(InitialData(idioma, 'id_given'));
        setMachine(InitialData(idioma, 'machine'));

        setNamePtBr(InitialData(idioma, 'name_pt_br'));
        setNameEn(InitialData(idioma, 'name_en'));
        setNameEs(InitialData(idioma, 'name_es'));

        setPosition(InitialData(idioma, 'position'));
        setStamp_1(InitialData(idioma, 'stamp_1'));
        setStamp_2(InitialData(idioma, 'stamp_2'));
        setContents(InitialData(idioma, 'contents'));
        setHighlight(InitialData(idioma, 'highlight'));

        setSubtitlePtBr(InitialData(idioma, 'subtitle_pt_br'));
        setSubtitleEn(InitialData(idioma, 'subtitle_en'));
        setSubtitleEs(InitialData(idioma, 'subtitle_es'));

        setIconePtBr(InitialData(idioma, 'icone_pt_br'));
        setIconeEn(InitialData(idioma, 'icone_en'));
        setIconeEs(InitialData(idioma, 'icone_es'));

        setQrCode(InitialData(idioma, 'qrCode'));

        setTitlePtBr(InitialData(idioma, 'title_pt_br'));
        setTitleEn(InitialData(idioma, 'title_en'));
        setTitleEs(InitialData(idioma, 'title_es'));

        setImgQrCodePtBr(InitialData(idioma, 'imgQrCode_pt_br'));
        setImgQrCodeEn(InitialData(idioma, 'imgQrCode_en'));
        setImgQrCodeEs(InitialData(idioma, 'imgQrCode_es'));

        setStatusIconePtBr(false);
        setStatusIconeEn(false);
        setStatusIconeEs(false);

        setStatusQrCodePtBr(false);
        setStatusQrCodeEn(false);
        setStatusQrCodeEs(false);
    }, [idPage]);

    function InitialData(typeIdioma, type){
        if(idPage !=0){
            const newData = dataPage.find(item => item.id == idPage);
            if(type == 'id_given'){
                let dataButton = showButton.find(item => item.id == newData[type]);
                if(dataButton){
                    switch (typeIdioma) {
                        case "pt_br":
                            return { "value": dataButton.id, "label": dataButton.name_pt_br };

                        case "en":
                            return { "value": dataButton.id, "label": dataButton.name_en };

                        case "es":
                            return { "value": dataButton.id, "label": dataButton.name_es };
                    }
                }
                return { "value": 0, "label": "#" }
            }
            if(type == 'stamp_1'){
                switch (newData[type]) {
                    case "Não":
                        return { "value": newData[type], "label": "Não" };
                    case "stamp_1.png":
                        return { "value": newData[type], "label": "12 Meses" };
                    case "stamp_2.png":
                        return { "value": newData[type], "label": "6 anos" };
                    case "stamp_3.png":
                        return { "value": newData[type], "label": "8 anos" };
                }  
            }
            if(type == 'stamp_2'){
                switch (newData[type]) {
                    case "Não":
                        return { "value": newData[type], "label": "Não" };
                    case "stamp_4.png":
                        return { "value": newData[type], "label": "Selo 12%" };
                    case "stamp_5.png":
                        return { "value": newData[type], "label": "Selo 1.9%" };
                }  
            }
            if(type == 'machine' || type == 'qrCode' || type == 'highlight'){
                return { "value": newData[type], "label": newData[type] }; 
            }
            if(type == 'position'){
                switch (newData[type]) {
                    case "left":
                        return { "value": newData[type], "label": "Esquerda" };
                    case "right":
                        return { "value": newData[type], "label": "Direita" };
                }  
            }
            return newData[type];
        }
        if(type == 'qrCode' || type == 'highlight'){
            console.log('Teste 123');
            return { "value": "Não", "label": "Não" }; 
        }
        
        if(type == 'contents'){
            return [{ "id": 0, "column": 0, "status": false, "type": "text", "text": "", "video": "", "video_img": "", "statusVideo": false, "img": [{ "id": 0, "status": false, "img": "" }] }, { "id": 0, "column": 0, "status": false, "type": "img", "text": "", "video": "", "video_img": "", "statusVideo": false, "img": [{ "id": 0, "status_pt_br": false, "img_pt_br": "", "status_en": false, "img_en": "", "status_es": false, "img_es": "" }] }];
        }
        return '';
    }

    function ShowButtons(){
        const options = [];
        if(idioma == 'pt_br'){
            showButton.map((key, index)=>{
                options.push({
                    "value": key.id, "label": key.name_pt_br
                });
            })
        }
        if(idioma == 'en'){
            showButton.map((key, index)=>{
                options.push({
                    "value": key.id, "label": key.name_en
                });
            })
        }
        if(idioma == 'es'){
            showButton.map((key, index)=>{
                options.push({
                    "value": key.id, "label": key.name_es
                });
            })
        }
        return options;
    }

    function ReturnPage(){
        SetListPag('currentPage', 'mesa_part_service');
        SetListPag('currentPageId', 'remuve');
    }

    function SaveData(event){
        event.preventDefault();
        setLoading(true);
        Reg_PartService(idPage, type.value, machine.value, position.value, stamp_1.value, stamp_2.value, qrCode.value, titlePtBr, titleEn, titleEs, imgQrCodePtBr, imgQrCodeEn, imgQrCodeEs, namePtBr, nameEn, nameEs, contents, highlight.value, subtitlePtBr, subtitleEn, subtitleEs, ()=>{ CallbackSuccess() }, ()=>{ CallbackError() });
    }

    function CallbackSuccess(){
        setLoading(false);
        SetModalData('ReturnResponse', { "page": "ok" });
        SetModalState('ReturnResponse', true);
    }

    function CallbackError(){
        setLoading(false);
        SetModalData('ReturnResponse', { "page": "erro" });
        SetModalState('ReturnResponse', true);
    }

    function AddFile(type, value){
        if(type == 'qrcode'){
            switch (idioma) {
                case "pt_br":
                        if(value){
                            setStatusQrCodePtBr(true);
                            setImgQrCodePtBr(value);
                        }else {
                            setStatusQrCodePtBr(false);
                            setImgQrCodePtBr('');
                        }
                    break;

                case "en":
                        if(value){
                            setStatusQrCodeEn(true);
                            setImgQrCodeEn(value);
                        }else {
                            setStatusQrCodeEn(false);
                            setImgQrCodeEn('');
                        }
                    break;

                case "es":
                        if(value){
                            setStatusQrCodeEs(true);
                            setImgQrCodeEs(value);
                        }else {
                            setStatusQrCodeEs(false);
                            setImgQrCodeEs('');
                        }
                    break;
            }
        }else if(type == 'icone'){
            switch (idioma) {
                case "pt_br":
                        if(value){
                            setStatusIconePtBr(true);
                            setIconePtBr(value);
                        }else {
                            setStatusIconePtBr(false);
                            setIconePtBr('');
                        }
                    break;

                case "en":
                        if(value){
                            setStatusIconeEn(true);
                            setIconeEn(value);
                        }else {
                            setStatusIconeEn(false);
                            setIconeEn('');
                        }
                    break;

                case "es":
                        if(value){
                            setStatusIconeEs(true);
                            setIconeEs(value);
                        }else {
                            setStatusIconeEs(false);
                            setIconeEs('');
                        }
                    break;
            }
        }

    }

    function OpenFile(type, value){
        SetModalData("ShowFile", { "type": type, "file": value });
        SetModalState('ShowFile', true);
    }

    function NewContents(index){
        const newData = [...contents];
        newData.push({
            "id": 0, "column": 0, "type": "img", "text_pt_br": "", "text_en": "", "text_es": "", "title_pt_br": "", "title_en": "", "title_es": "", "video_pt_br": "", "video_en": "", "video_es": "", "statusVideo_pt_br": false, "statusVideo_en": false, "statusVideo_es": false, "video_img_pt_br": "", "video_img_en": "", "video_img_es": "", "statusVideoImg_pt_br": false, "statusVideoImg_en": false, "statusVideoImg_es": false, "img": [{ "id": 0, "status_pt_br": false, "img_pt_br": "", "status_en": false, "img_en": "", "status_es": false, "img_es": "" }] })

        setContents(newData);
    }

    function NewPhoto(index){
        const newData = [...contents];
        newData[index].img.push({ "id": 0, "status_pt_br": false, "img_pt_br": "", "status_en": false, "img_en": "", "status_es": false, "img_es": "" });
        setContents(newData);
    }
    
    function HandleData(type, index, value, index_1){
        const newData = [...contents];
        // img
        if(type == 'img_pt_br'){
            if(value){
                newData[index].img[index_1]['img_pt_br'] = value;
                newData[index].img[index_1].status_pt_br = true;
            }else {
                newData[index].img[index_1]['img_pt_br'] = '';
                newData[index].img[index_1].status_pt_br = false;
            }
        }else if(type == 'img_en'){
            if(value){
                newData[index].img[index_1]['img_en'] = value;
                newData[index].img[index_1].status_en = true;
            }else {
                newData[index].img[index_1]['img_en'] = '';
                newData[index].img[index_1].status_en = false;
            }
        }else if(type == 'img_es'){
            if(value){
                newData[index].img[index_1]['img_es'] = value;
                newData[index].img[index_1].status_es = true;
            }else {
                newData[index].img[index_1]['img_es'] = '';
                newData[index].img[index_1].status_es = false;
            }
        }
        // img video
        else if(type == 'video_img_pt_br'){
            if(value){
                newData[index]['video_img_pt_br']     = value;
                newData[index]['statusVideoImg_pt_br'] = true;
            }else {
                newData[index][type]     = '';
                newData[index]['statusVideoImg_pt_br'] = false;
            }
        }else if(type == 'video_img_en'){
            if(value){
                newData[index]['video_img_en']     = value;
                newData[index]['statusVideoImg_en'] = true;
            }else {
                newData[index]['video_img_en']     = '';
                newData[index]['statusVideoImg_en'] = false;
            }
        }else if(type == 'video_img_es'){
            if(value){
                newData[index]['video_img_es']     = value;
                newData[index]['statusVideoImg_es'] = true;
            }else {
                newData[index]['video_img_es']     = '';
                newData[index]['statusVideoImg_es'] = false;
            }
        }
        // video
        else if(type == 'video_pt_br'){
            if(value){
                newData[index]['video_pt_br']          = value;
                newData[index]['statusVideo_pt_br'] = true;
            }else {
                newData[index]['video_pt_br']          = '';
                newData[index]['statusVideo_pt_br'] = false;
            }
        }else if(type == 'video_en'){
            if(value){
                newData[index]['video_en']          = value;
                newData[index]['statusVideo_en'] = true;
            }else {
                newData[index]['video_en']          = '';
                newData[index]['statusVideo_en'] = false;
            }
        }else if(type == 'video_es'){
            if(value){
                newData[index]['video_es']          = value;
                newData[index]['statusVideo_es'] = true;
            }else {
                newData[index]['video_es']          = '';
                newData[index]['statusVideo_es'] = false;
            }
        }
        
        else {
            newData[index][type] = value;
        }
        setContents(newData);
    }

    function DeleteData(type, id, index, value, index_1){
        if(type == 'data'){
            if(id == 0){
                const newData = [...contents];
                newData.splice(index, 1);
                setContents(newData)
            }else {
                SetModalData("Confirmation", { "id": id, "origin": "mesa_part_service", "type": "delete_data_contents", "name": value });
                SetModalState('Confirmation', true);
            }
        }else {
            if(id == 0){
                const newData = [...contents];
                newData[index].img.splice(index_1, 1);
                setContents(newData)
            }else {
                SetModalData("Confirmation", { "id": id, "origin": "mesa_part_service", "type": "delete_data_photo", "name": value });
                SetModalState('Confirmation', true);
            }
        }
    }

    function CopyData(){
        SetModalData("Confirmation", { "id": idPage, "origin": "mesa_part_service", "type": "copy_data", "name": "Copiar dados", "idUser": idUser });
        SetModalState('Confirmation', true);
    }

    return(
        <div className="Page_PartsServices_Details">
            <div className={ loading == true ? "return_data_save div_loading" : "return_data_save" }>
                <img alt="loading" src="./assets/loading.gif" className="loading" />
            </div>
            <form onSubmit={ SaveData }>
                <div className="new_block">
                    <div className="div_name_page">
                        <div className="name_fixed">
                            Dashboard
                        </div>
                        <div className="show_icon">
                            <SvgSetaRight color="#CDD1D6" className="icons" />
                        </div>
                        <div className="name_fixed page_return" onClick={ ()=>{ ReturnPage() } }>
                            Peças e serviços
                        </div>
                        <div className="show_icon" onClick={ ()=>{ ReturnPage() } }>
                            <SvgSetaRight color="#CDD1D6" className="icons" />
                        </div>
                        <div className="name_page">
                            Detalhes
                        </div>
                    </div>
                    <div className="list_opt_alt_page">
                        <div className="div_icons" onClick={ ()=>{ CopyData() } }>
                            <SvgCopy color="#324d6b" className="icons" />
                        </div>
                        <button className="new_block_text">
                            <div className="">
                                <SvgSave color="#ffffff" className="icons" />
                            </div>
                            <div className="">
                                Salvar
                            </div>
                        </button>
                    </div>
                </div>
                
                <div className="div_idioma">
                    <div className={ idioma == 'pt_br' ? "idioma idioma_active" : "idioma" } onClick={ ()=>{ setIdioma('pt_br') } }>Português</div>
                    <div className={ idioma == 'en' ? "idioma idioma_active" : "idioma" } onClick={ ()=>{ setIdioma('en') } }>Inglês</div>
                    <div className={ idioma == 'es' ? "idioma idioma_active" : "idioma" } onClick={ ()=>{ setIdioma('es') } }>Espanhol</div>
                </div>
                
                <div className="show_page_data">
                    <div className="list_type_data">
                        <div className="type_title">
                            <SvgTable color="#2D3C53" className="icons" />
                            Dados da mesa - Peças e serviços
                        </div>
                    </div>
                    <div className="list_input_data">
                        <div className="div_input">
                            <Select className="select_2" defaultOptions options={ ShowButtons() } onChange={ (e)=> { setType(e) } } value={ type } placeholder="..." required />
                            <span className="name_input">{ textFixed.text_2[idioma] }</span>
                        </div>
                        <div className="div_input">
                            <Select className="select_1" defaultOptions options={[ { "value": "left", "label": "Esquerda" }, { "value": "right", "label": "Direita" } ]} onChange={ (e)=> { setPosition(e) } } value={ position } placeholder="..." required />
                            <span className="name_input">{ textFixed.text_3[idioma] }</span>
                        </div>
                        <div className="div_input">
                            {
                                idioma == 'pt_br' ? 
                                    <input type="text" onChange={ (e)=>{ setNamePtBr(e.target.value) } } value={ namePtBr } maxLength="60" /> :
                                    idioma == 'en' ?
                                        <input type="text" onChange={ (e)=>{ setNameEn(e.target.value) } } value={ nameEn } maxLength="60" /> : 
                                        <input type="text" onChange={ (e)=>{ setNameEs(e.target.value) } } value={ nameEs } maxLength="60" />
                            }
                            <span className="name_input">{ textFixed.text_16[idioma] }</span>
                        </div>                   
                        <div className="div_input">
                            <Select className="select_1" defaultOptions options={[ { "value": "Não", "label": "Não" }, { "value": "stamp_1.png", "label": "12 meses" }, { "value": "stamp_2.png", "label": "6 anos" }, { "value": "stamp_3.png", "label": "8 anos" } ]} onChange={ (e)=> { setStamp_1(e) } } value={ stamp_1 } placeholder="..." required />
                            <span className="name_input">{ textFixed.text_4[idioma] }</span>
                        </div>
                        <div className="div_input">
                            <Select className="select_3" defaultOptions options={[ { "value": "Não", "label": "Não" }, { "value": "stamp_4.png", "label": "Selo 12%" }, { "value": "stamp_5.png", "label": "Selo 1.9%" } ]} onChange={ (e)=> { setStamp_2(e) } } value={ stamp_2 } placeholder="..." required />
                            <span className="name_input">{ textFixed.text_5[idioma] }</span>
                        </div>
                        <div className="div_input">
                            <Select className="select_1" defaultOptions options={[ { "value": "Não", "label": "Não" }, { "value": "Sim", "label": "Sim" } ]} onChange={ (e)=> { setQrCode(e) } } value={ qrCode } placeholder="..." required />
                            <span className="name_input">QrCode</span>
                        </div>
                    </div>
                    {
                        qrCode.value == "Não" ? null :
                        <div className="list_input_data">
                            <div className="div_input space_div">
                                {
                                    idioma == 'pt_br' ? 
                                    <input type="text" onChange={ (e)=>{ setTitlePtBr(e.target.value) } } value={ titlePtBr } maxLength="60" required /> :
                                        idioma == 'en' ? 
                                        <input type="text" onChange={ (e)=>{ setTitleEn(e.target.value) } } value={ titleEn } maxLength="60" required /> : 
                                        <input type="text" onChange={ (e)=>{ setTitleEs(e.target.value) } } value={ titleEs } maxLength="60" required />
                                }
                                <span className="name_input">{ textFixed.text_17[idioma] }</span>
                            </div>    
                            {
                                idioma == 'pt_br' ? 
                                <>                                                      
                                    <div className={ statusQrCodePtBr == true ? "div_input new_file_add new_file_add_active" : "div_input new_file_add" }>
                                        <label>
                                            { statusQrCodePtBr == true ? textFixed.text_19[idioma] : textFixed.text_18[idioma] }
                                            <input type="file" onChange={ (e)=>{ AddFile('qrcode', e.target.files[0]); } } accept="image/*" />
                                        </label>
                                    </div>
                                    {
                                        imgQrCodePtBr !='' ?
                                            statusQrCodePtBr == true ?
                                                <div className="div_input show_img_" onClick={ ()=>{ OpenFile('showImg_local', URL.createObjectURL(imgQrCodePtBr)) } }>
                                                    <SvgImg color="#324d6b" className="icons"/>
                                                </div> :
                                                <div className="div_input show_img_" onClick={ ()=>{ OpenFile('showImg', "mesa/parts_service/" + imgQrCodePtBr) } }>
                                                    <SvgImg color="#324d6b" className="icons"/>
                                                </div>
                                        : null
                                    }
                                </> : 
                                    idioma == 'en' ?
                                    <>                                                      
                                        <div className={ statusQrCodeEn == true ? "div_input new_file_add new_file_add_active" : "div_input new_file_add" }>
                                            <label>
                                                { statusQrCodeEn == true ? textFixed.text_19[idioma] : textFixed.text_18[idioma] }
                                                <input type="file" onChange={ (e)=>{ AddFile('qrcode', e.target.files[0]); } } accept="image/*" />
                                            </label>
                                        </div>
                                        {
                                            imgQrCodeEn !='' ?
                                                statusQrCodeEn == true ?
                                                    <div className="div_input show_img_" onClick={ ()=>{ OpenFile('showImg_local', URL.createObjectURL(imgQrCodeEn)) } }>
                                                        <SvgImg color="#324d6b" className="icons"/>
                                                    </div> :
                                                    <div className="div_input show_img_" onClick={ ()=>{ OpenFile('showImg', "mesa/parts_service/" + imgQrCodeEn) } }>
                                                        <SvgImg color="#324d6b" className="icons"/>
                                                    </div>
                                            : null
                                        }
                                    </> : 
                                    <>                                                      
                                        <div className={ statusQrCodeEs == true ? "div_input new_file_add new_file_add_active" : "div_input new_file_add" }>
                                            <label>
                                                { statusQrCodeEs == true ? textFixed.text_19[idioma] : textFixed.text_18[idioma] }
                                                <input type="file" onChange={ (e)=>{ AddFile('qrcode', e.target.files[0]); } } accept="image/*" />
                                            </label>
                                        </div>
                                        {
                                            imgQrCodeEs !='' ?
                                                statusQrCodeEs == true ?
                                                    <div className="div_input show_img_" onClick={ ()=>{ OpenFile('showImg_local', URL.createObjectURL(imgQrCodeEs)) } }>
                                                        <SvgImg color="#324d6b" className="icons"/>
                                                    </div> :
                                                    <div className="div_input show_img_" onClick={ ()=>{ OpenFile('showImg', "mesa/parts_service/" + imgQrCodeEs) } }>
                                                        <SvgImg color="#324d6b" className="icons"/>
                                                    </div>
                                            : null
                                        }
                                    </>
                            }
                        </div>
                    }
                </div>

                <div className="show_page_data">
                    <div className="list_type_data">
                        <div className="type_title">
                            { textFixed.text_8[idioma] }
                        </div>
                        <div className="">
                            <div className="new_data_page" onClick={ ()=>{ NewContents() } }>
                                + { textFixed.text_8[idioma] }
                            </div>
                        </div>
                    </div>
                    {
                        contents.length > 0 ?
                            <div className="list_data_list">
                                {
                                    contents.map((key, index) =>{
                                        return(
                                            <div className={ key.type == 'img' ? "div_data_contents div_img" : "div_data_contents" } key={ index }>
                                                <div className="show_contents">
                                                    <div className="div_input">
                                                        <select className="" onChange={ (e)=>{ HandleData('type', index, e.target.value) } } value={ key.type } required>
                                                            <option value="img">{ textFixed.text_10[idioma] }</option>
                                                            <option value="text">{ textFixed.text_11[idioma] }</option>
                                                            <option value="video">Vídeo</option>
                                                        </select>
                                                        <span className="name_input">{ textFixed.text_9[idioma] }</span>
                                                    </div>
                                                    <div className="div_input" onClick={ ()=>{ DeleteData('data', key.id, index, key.type) } }>
                                                        <SvgDelete color="#F00000" className="icons" />
                                                    </div> 
                                                    {
                                                        key.type != 'img' ? null :
                                                        <div className="div_input" onClick={ ()=>{ NewPhoto(index); } }>
                                                            <SvgAddData color="#2D3C53" className="icons" />
                                                        </div>
                                                    }
                                                </div>
                                                {
                                                    key.type == 'img' ? 
                                                    <>
                                                        {
                                                            key.img.map((key_1, index_1)=>{
                                                                return(
                                                                    <div className="show_contents" key={ index_1 }>
                                                                        {
                                                                            idioma == 'pt_br' ?
                                                                                <>
                                                                                    <div className={ key_1.status_pt_br == true ? "new_file_add new_file_add_active" : "new_file_add" }>
                                                                                        <label>
                                                                                            { key_1.status_pt_br == true ? textFixed.text_13[idioma] : textFixed.text_12[idioma] }
                                                                                            <input type="file" onChange={ (e)=>{ HandleData('img_pt_br', index, e.target.files[0], index_1); } } accept="image/*" />
                                                                                        </label>
                                                                                    </div>
                                                                                    {
                                                                                        key_1.img_pt_br !='' ?
                                                                                            key_1.status_pt_br == true ?
                                                                                            <div className="show_img_" onClick={ ()=>{ OpenFile('showImg_local', URL.createObjectURL(key_1.img_pt_br)) } }>
                                                                                                <SvgImg color="#324d6b" className="icons"/>
                                                                                            </div> :
                                                                                            <div className="show_img_" onClick={ ()=>{ OpenFile('showImg', "mesa/parts_service/" + key_1.img_pt_br) } }>
                                                                                                <SvgImg color="#324d6b" className="icons"/>
                                                                                            </div>
                                                                                        : null
                                                                                    }
                                                                                </> :
                                                                                idioma == 'en' ?
                                                                                <>
                                                                                    <div className={ key_1.status_en == true ? "new_file_add new_file_add_active" : "new_file_add" }>
                                                                                        <label>
                                                                                            { key_1.status_en == true ? textFixed.text_13[idioma] : textFixed.text_12[idioma] }
                                                                                            <input type="file" onChange={ (e)=>{ HandleData('img_en', index, e.target.files[0], index_1); } } accept="image/*" />
                                                                                        </label>
                                                                                    </div>
                                                                                    {
                                                                                        key_1.img_en !='' ?
                                                                                            key_1.status_en == true ?
                                                                                            <div className="show_img_" onClick={ ()=>{ OpenFile('showImg_local', URL.createObjectURL(key_1.img_en)) } }>
                                                                                                <SvgImg color="#324d6b" className="icons"/>
                                                                                            </div> :
                                                                                            <div className="show_img_" onClick={ ()=>{ OpenFile('showImg', "mesa/parts_service/" + key_1.img_en) } }>
                                                                                                <SvgImg color="#324d6b" className="icons"/>
                                                                                            </div>
                                                                                        : null
                                                                                    }
                                                                                </> :
                                                                                <>
                                                                                    <div className={ key_1.status_es == true ? "new_file_add new_file_add_active" : "new_file_add" }>
                                                                                        <label>
                                                                                            { key_1.status_es == true ? textFixed.text_13[idioma] : textFixed.text_12[idioma] }
                                                                                            <input type="file" onChange={ (e)=>{ HandleData('img_es', index, e.target.files[0], index_1); } } accept="image/*" />
                                                                                        </label>
                                                                                    </div>
                                                                                    {
                                                                                        key_1.img_es !='' ?
                                                                                            key_1.status_es == true ?
                                                                                            <div className="show_img_" onClick={ ()=>{ OpenFile('showImg_local', URL.createObjectURL(key_1.img_es)) } }>
                                                                                                <SvgImg color="#324d6b" className="icons"/>
                                                                                            </div> :
                                                                                            <div className="show_img_" onClick={ ()=>{ OpenFile('showImg', "mesa/parts_service/" + key_1.img_es) } }>
                                                                                                <SvgImg color="#324d6b" className="icons"/>
                                                                                            </div>
                                                                                        : null
                                                                                    }
                                                                                </>
                                                                        }
                                                                        <div className="" onClick={ ()=>{ DeleteData('img', key_1.id, index, key_1.type, index_1) } }>
                                                                            <SvgDelete color="#F00000" className="icons" />
                                                                        </div> 
                                                                    </div>
                                                                )
                                                            })
                                                        }
                                                    </>
                                                    :
                                                    <>
                                                        {
                                                            key.type == 'video' ? 

                                                                idioma == 'pt_br' ?
                                                                    <>
                                                                        <div className="show_contents">
                                                                            <div className={ key.statusVideoImg_pt_br == true ? "new_file_add new_file_add_active" : "new_file_add" }>
                                                                                <label>
                                                                                    { key.statusVideoImg_pt_br == true ? textFixed.text_13[idioma] : textFixed.text_12[idioma] }
                                                                                    <input type="file" onChange={ (e)=>{ HandleData('video_img_pt_br', index, e.target.files[0], key); } } accept="image/*" />
                                                                                </label>
                                                                            </div>
                                                                            {
                                                                                key.video_img_pt_br !='' ?
                                                                                    key.statusVideoImg_pt_br == true ?
                                                                                    <div className="show_img_" onClick={ ()=>{ OpenFile('showImg_local', URL.createObjectURL(key.video_img_pt_br)) } }>
                                                                                        <SvgImg color="#324d6b" className="icons"/>
                                                                                    </div> :
                                                                                    <div className="show_img_" onClick={ ()=>{ OpenFile('showImg', "mesa/parts_service/" + key.video_img_pt_br) } }>
                                                                                        <SvgImg color="#324d6b" className="icons"/>
                                                                                    </div>
                                                                                : null
                                                                            }
                                                                            <div className={ key.statusVideo_pt_br == true ? "new_file_add new_file_add_active" : "new_file_add" }>
                                                                                <label>
                                                                                    { key.statusVideo_pt_br == true ? textFixed.text_15[idioma] : textFixed.text_14[idioma] }
                                                                                    <input type="file" onChange={ (e)=>{ HandleData('video_pt_br', index, e.target.files[0], key); } } accept="video/*" />
                                                                                </label>
                                                                            </div>
                                                                            {
                                                                                key.video_pt_br !='' ?
                                                                                    key.statusVideo_pt_br == true ?
                                                                                    <div className="show_img_" onClick={ ()=>{ OpenFile('showVideo_local', URL.createObjectURL(key.video_pt_br)) } }>
                                                                                        <SvgVideo color="#324d6b" className="icons"/>
                                                                                    </div> :
                                                                                    <div className="show_img_" onClick={ ()=>{ OpenFile('showVideo', "mesa/parts_service/" + key.video_pt_br) } }>
                                                                                        <SvgVideo color="#324d6b" className="icons"/>
                                                                                    </div>
                                                                                : null
                                                                            }
                                                                        </div>
                                                                        <div className="show_contents">
                                                                            <div className="div_input space_div">
                                                                                <input type="text" onChange={ (e)=>{ HandleData('title_pt_br', index, e.target.value) } } value={ key.title_pt_br } maxLength="140" />
                                                                                <span className="name_input">{ textFixed.text_17[idioma] }</span>
                                                                            </div> 
                                                                        </div> 
                                                                    </>
                                                                    :
                                                                    idioma == 'en' ?
                                                                    <>
                                                                        <div className="show_contents">
                                                                            <div className={ key.statusVideo_en == true ? "new_file_add new_file_add_active" : "new_file_add" }>
                                                                                <label>
                                                                                    { key.statusVideo_en == true ? textFixed.text_13[idioma] : textFixed.text_12[idioma] }
                                                                                    <input type="file" onChange={ (e)=>{ HandleData('video_img_en', index, e.target.files[0], key); } } accept="image/*" />
                                                                                </label>
                                                                            </div>
                                                                            {
                                                                                key.video_img_en !='' ?
                                                                                    key.statusVideo_en == true ?
                                                                                    <div className="show_img_" onClick={ ()=>{ OpenFile('showImg_local', URL.createObjectURL(key.video_img_en)) } }>
                                                                                        <SvgImg color="#324d6b" className="icons"/>
                                                                                    </div> :
                                                                                    <div className="show_img_" onClick={ ()=>{ OpenFile('showImg', "mesa/parts_service/" + key.video_img_en) } }>
                                                                                        <SvgImg color="#324d6b" className="icons"/>
                                                                                    </div>
                                                                                : null
                                                                            }
                                                                            <div className={ key.status_en == true ? "new_file_add new_file_add_active" : "new_file_add" }>
                                                                                <label>
                                                                                    { key.status_en == true ? textFixed.text_15[idioma] : textFixed.text_14[idioma] }
                                                                                    <input type="file" onChange={ (e)=>{ HandleData('video_en', index, e.target.files[0], key); } } accept="video/*" />
                                                                                </label>
                                                                            </div>
                                                                            {
                                                                                key.video_en !='' ?
                                                                                    key.status_en == true ?
                                                                                    <div className="show_img_" onClick={ ()=>{ OpenFile('showVideo_local', URL.createObjectURL(key.video_en)) } }>
                                                                                        <SvgVideo color="#324d6b" className="icons"/>
                                                                                    </div> :
                                                                                    <div className="show_img_" onClick={ ()=>{ OpenFile('showVideo', "mesa/parts_service/" + key.video_en) } }>
                                                                                        <SvgVideo color="#324d6b" className="icons"/>
                                                                                    </div>
                                                                                : null
                                                                            }
                                                                        </div>
                                                                        <div className="show_contents">
                                                                            <div className="div_input space_div">
                                                                                <input type="text" onChange={ (e)=>{ HandleData('title_en', index, e.target.value) } } value={ key.title_en } maxLength="140" />
                                                                                <span className="name_input">{ textFixed.text_17[idioma] }</span>
                                                                            </div> 
                                                                        </div> 
                                                                    </>
                                                                    : 
                                                                    <>
                                                                        <div className="show_contents">
                                                                            <div className={ key.statusVideo_es == true ? "new_file_add new_file_add_active" : "new_file_add" }>
                                                                                <label>
                                                                                    { key.statusVideo_es == true ? textFixed.text_13[idioma] : textFixed.text_12[idioma] }
                                                                                    <input type="file" onChange={ (e)=>{ HandleData('video_img_es', index, e.target.files[0], key); } } accept="image/*" />
                                                                                </label>
                                                                            </div>
                                                                            {
                                                                                key.video_img_es !='' ?
                                                                                    key.statusVideo_es == true ?
                                                                                    <div className="show_img_" onClick={ ()=>{ OpenFile('showImg_local', URL.createObjectURL(key.video_img_es)) } }>
                                                                                        <SvgImg color="#324d6b" className="icons"/>
                                                                                    </div> :
                                                                                    <div className="show_img_" onClick={ ()=>{ OpenFile('showImg', "mesa/parts_service/" + key.video_img_es) } }>
                                                                                        <SvgImg color="#324d6b" className="icons"/>
                                                                                    </div>
                                                                                : null
                                                                            }
                                                                            <div className={ key.status_es == true ? "new_file_add new_file_add_active" : "new_file_add" }>
                                                                                <label>
                                                                                    { key.status_es == true ? textFixed.text_15[idioma] : textFixed.text_14[idioma] }
                                                                                    <input type="file" onChange={ (e)=>{ HandleData('video_es', index, e.target.files[0], key); } } accept="video/*" />
                                                                                </label>
                                                                            </div>
                                                                            {
                                                                                key.video_es !='' ?
                                                                                    key.status_es == true ?
                                                                                    <div className="show_img_" onClick={ ()=>{ OpenFile('showVideo_local', URL.createObjectURL(key.video_es)) } }>
                                                                                        <SvgVideo color="#324d6b" className="icons"/>
                                                                                    </div> :
                                                                                    <div className="show_img_" onClick={ ()=>{ OpenFile('showVideo', "mesa/parts_service/" + key.video_es) } }>
                                                                                        <SvgVideo color="#324d6b" className="icons"/>
                                                                                    </div>
                                                                                : null
                                                                            }
                                                                        </div>
                                                                        <div className="show_contents">
                                                                            <div className="div_input space_div">
                                                                                <input type="text" onChange={ (e)=>{ HandleData('title_es', index, e.target.value) } } value={ key.title_es } maxLength="140" />
                                                                                <span className="name_input">{ textFixed.text_17[idioma] }</span>
                                                                            </div> 
                                                                        </div> 
                                                                    </>
                                                                : 
                                                            <div className="show_contents">
                                                                <JoditEditor config={ config } value={
                                                                    idioma == 'pt_br' ? 
                                                                        key.text_pt_br ? key.text_pt_br.replaceAll('&#34;', '"') : "" :
                                                                        idioma == 'en' ? 
                                                                            key.text_en ? key.text_en.replaceAll('&#34;', '"') : "" :
                                                                            key.text_es ? key.text_es.replaceAll('&#34;', '"') : ""
                                                                } onBlur={ newContent => HandleData('text_' + idioma, index, newContent) } />
                                                            </div>
                                                        }
                                                    </>
                                                }   
                                            </div>
                                        )
                                    })
                                }
                            </div>
                        :                      
                        <div className="list_input_data" style={ { marginBottom: 0 } }>
                            <div className="no_data">Nenhum conteúdo encontrada...</div>
                        </div>
                    }
                </div>
            </form>
        </div>
    )
}